import TransactionInquiry from './transaction-inquiry.vue'
export default TransactionInquiry
